// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ComponentEditController = function ($rootScope,
    $scope,
    $location,
    $routeParams,
    $q,
    $modal,
    ProductInfo,
    Component,
    ComponentByPlanGroup,
    PlanGroup,
    ProductPrices,
    PriceListItems,
    TaxPolicy,
    CustomFieldSettings) {

    $scope.pricingModel = "0";
    $scope.clonedComponentPriceListItems = [];
    $scope.oldCollection = [];

    if ($routeParams.componentId) {
        $scope.productInfo = ProductInfo.get(function () {
            $scope.component = Component.get({componentId: $routeParams.componentId}, function () {
                if ($scope.component.PricePerUnit == null) $scope.pricingModel = "3";
                if ($scope.component.PriceScale != null) $scope.pricingModel = "1";
                if ($scope.component.DiscountScale != null) $scope.pricingModel = "2";
                $scope.planGroup = PlanGroup.get({planGroupId: $scope.component.PlanGroupId}, function () {
                    $scope.updateFilter();
                });
                $scope.isBucketPricing = ($scope.component.PriceScale || {}).IsCumulative || false;
            });
            $scope.taxPolicies = TaxPolicy.query();
        });
    } else {
        $scope.productInfo = ProductInfo.get(function () {
            $scope.component = new ComponentByPlanGroup();
            $scope.component.CustomFields = {};
            $scope.component.PlanGroupId = $routeParams.planGroupId;
            $scope.component.FeePeriod = {"Quantity": 1, "Unit": "Month"};
            $scope.planGroup = PlanGroup.get({planGroupId: $routeParams.planGroupId}, function () {
                $scope.updateFilter();
            });
            $scope.taxPolicies = TaxPolicy.query({}, function () {
                $scope.component.TaxPolicyId = TaxPolicy.getDefaultTaxPolicyId($scope.taxPolicies);
            });
        });
    }

    if (!$scope.search)
        $scope.search = "";

    $scope.updateFilter = function () {
        ProductPrices.query({ productId: $routeParams.componentId, planGroupId: $scope.planGroup.Id, search: $scope.search}).$promise.then(
            function (response){
                if (response.length === 1 && ($scope.search === "" || !$scope.search)) {
                    if (!response[0].OneOffPrice && !response[0].RecurringPrice) $scope.DefinePrice(response[0]);
                    $scope.onePriceListItem = true;
                } else {
                    $scope.onePriceListItem = false;
                }

                $scope.fullcomponentPriceListItems = response.map(obj => ({...obj, Id: obj.PriceListId}));

                $scope.componentPriceListItems = $scope.paginator(function (options, callback) {
                    let list = null;
                    let index = 0;
                    if (options.from !== "") {
                        index = $scope.fullcomponentPriceListItems.findIndex(x=>x.Id === options.from)
                    }
                    list = $scope.fullcomponentPriceListItems.slice(index, index + options.take);

                    let query = function(success){
                        let deferred = $q.defer();
                        let promise = deferred.promise;
                        promise.then(success);
                        deferred.resolve(list);
                        return promise.$$state.value;
                    };
                    return query(function(){
                        if ($scope.unsavedItems > 0) {
                            return;
                        }
                        callback();
                        setupDirty();
                        SetIsOverriddenFlagAndCloneItems();
                    });
                }, {
                    componentId: $routeParams.componentId,
                    planGroupId: $scope.planGroup.Id,
                    search: $scope.search
                }, 20);

                $scope.componentPriceListItems.first = $scope.overrideStep($scope.componentPriceListItems.first);
                $scope.componentPriceListItems.next = $scope.overrideStep($scope.componentPriceListItems.next);
                $scope.componentPriceListItems.prev = $scope.overrideStep($scope.componentPriceListItems.prev);
            });
    };

    function SetIsOverriddenFlagAndCloneItems() {
        $scope.componentPriceListItems.items.forEach(function (item) {
            if (!item.ParentPriceListId) {
                item.IsOverridden = false;
                return;
            }

            const parentItem = getComponentItem(item);

            // If item in Child PL doesn't have defined 'RecurringPrice' and a linked Parent Pl has an item with defined 'RecurringPrice', child item 'inherits' values from the parent item.
            if (!item.RecurringPrice && parentItem?.RecurringPrice) {
                item.RecurringPrice = {...parentItem.RecurringPrice};
                item.IsOverridden = false;
            } else if (item.OneOffPrice && item.RecurringPrice)
                item.IsOverridden = true;
        });

        $scope.oldCollection = JSON.parse(JSON.stringify($scope.componentPriceListItems.items));
        $scope.clonedComponentPriceListItems = JSON.parse(JSON.stringify($scope.componentPriceListItems.items));
    }

    function getComponentItem(item){
        let priceListItem = null;
        const parentPriceListItem = $scope.fullcomponentPriceListItems.find(pl => pl.Id === item.ParentPriceListId) ||
            $scope.productInfo.PriceLists.find(x => x.Id === item.PriceListId).ParentItems?.find(x => x.ProductId === item.ProductId);
        if (parentPriceListItem && parentPriceListItem?.RecurringPrice) {
            priceListItem = parentPriceListItem;
        }
        else if (parentPriceListItem && parentPriceListItem.ParentPriceListId) {
            priceListItem = getComponentItem(parentPriceListItem);
        }
        return priceListItem;
    }

    function clearDirty() {
        $scope.componentPriceListItems.items.map(function (x) {
            x.dirty = false;
            x.RequestedAction = undefined;
        });
        $scope.unsavedItems = 0;
    }

    function setupDirty() {
        clearDirty();
        $scope.$watch(function () {
            return $scope.componentPriceListItems.items;
        }, function (newCollection) {
            let difference = newCollection.filter(function (newItem) {
                let result = true;
                $scope.oldCollection.forEach(function (oldItem) {
                    if (angular.equals(newItem, oldItem)) result = false;
                });
                return result;
            });

            difference.forEach(function (newValue) {
                const oldValue = $scope.oldCollection.find(x=>x.Id === newValue.Id);
                // for child inherited items when we map price items from parent items, we don't want to mark them as dirty
                if (oldValue?.OneOffPrice && !newValue?.OneOffPrice && oldValue.ParentPriceListId)
                    newValue.dirty = false;
                else if (oldValue && oldValue.dirty === false && newValue.dirty === false) {
                    $scope.unsavedItems++;
                    newValue.dirty = true;
                }
            });
        }, true)
    }

    $scope.overrideStep = function (step){
        const oldStep = step;
        return function(){
            if($scope.unsavedItems){
                let modalInstance = $modal.open({
                    templateUrl: 'error-dialog.html',
                    controller: ['$scope', '$uibModal', 'error', function ($scope, $modalInstance, error) {
                        $scope.error = error;

                        $scope.close = function () {
                            modalInstance.close();
                        };
                    }],
                    windowClass: "fade in",
                    resolve: {
                        error: function () { return "You have made changes on this page which are not saved yet. Please save current page or cancel changes before changing page"; }
                    }
                });
                return;
            }
            oldStep();
        }
    }

    $scope.savePrices = function (success) {
        if (!$rootScope.isValid($scope.form2)) {
            $scope.form.$$element.context.reportValidity();
            return;
        }

        if ($routeParams.componentId) {
            $scope.componentPriceListItems.items.forEach(function (item) {
                if (!item.ProductId) {
                    item.ProductId = $scope.component.Id;
                    item.dirty = true; // For case when we have only 'Default' Price list and want to keep price value 0(preset value) we have to manually set to dirty to be saved.
                }
            })

            let data = {
                PriceListItems: $scope.componentPriceListItems.items.filter(x => x.RequestedAction !== priceListItemActionEnum.Inherit && x.RecurringPrice && x.dirty),
                RemovePriceListItems: $scope.componentPriceListItems.items.filter(x => x.RequestedAction === priceListItemActionEnum.Inherit && x.dirty)
            };

            if (success)
                PriceListItems.update(data, success);
            else {
                PriceListItems.update(data, function () {
                    SetIsOverridenFlagClearAndCloneItemsAfterUpdate(data);
                });
            }
        }
    };

    function SetIsOverridenFlagClearAndCloneItemsAfterUpdate(data) {
        data.PriceListItems.forEach((item) => {
            item.IsOverridden = !!item.ParentPriceListId;
            updateChildPriceListItems(item);
        });
        data.RemovePriceListItems.forEach((item) => {
            const parentItem = getComponentItem(item);
            if (parentItem)
                item.IsOverridden = false;

            updateChildPriceListItems(item);
        });
        clearDirty();
        $scope.oldCollection = JSON.parse(JSON.stringify($scope.componentPriceListItems.items));
        $scope.clonedComponentPriceListItems = JSON.parse(JSON.stringify($scope.componentPriceListItems.items));
    }

    function updateChildPriceListItems(priceListItem) {
        let items = $scope.fullcomponentPriceListItems.filter(x => x.ParentPriceListId == priceListItem.Id && !x.IsOverridden);
        if (items.length) {
            items.forEach(item => {
                item.RecurringPrice = { ...priceListItem.RecurringPrice };
                item.IsOverridden = item.IsOverridden ?? false;
                updateChildPriceListItems(item);
            })
        }
    }

    const priceListItemActionEnum = Object.freeze({
        "Define": "Define",
        "Override": "Override",
        "Inherit": "Inherit"
    });

    $scope.DefinePrice = function (item) {
        ResetPrice(item);
        item.RequestedAction = priceListItemActionEnum.Define;
    };

    $scope.OverridePrice = function (item) {
        ResetPrice(item);
        item.RequestedAction = priceListItemActionEnum.Override;
    };

    $scope.InheritPrice = function (item) {
        item.RequestedAction = priceListItemActionEnum.Inherit;
        const parentItem = getComponentItem(item);
        if (parentItem)
            item.RecurringPrice = {...parentItem.RecurringPrice};
    }

    function ResetPrice(item) {
        item.OneOffPrice = { PricePerUnit: null, PriceScale: null, DiscountScale: null };
        item.RecurringPrice = { PricePerUnit: 0, PriceScale: null, DiscountScale: null };
        item.IsOverridden = undefined;
    }

    $scope.ShowDefinePriceButton = function (item) {
        return item.RecurringPrice == null && !$scope.onePriceListItem && !item.ParentPriceListId
    }

    $scope.ShowOverridePriceButton = function (item) {
        if (item.RequestedAction || item.IsOverridden)
            return false;

        // Because we have not overriden item, in case of child we will show override button otherwise not
        return !!item.ParentPriceListId;
    }

    $scope.ShowInheritPriceButton = function (item) {
        if (item.RequestedAction)
            return false;

        const parentItem = getComponentItem(item);

        // If parent don't have RecurringPrice or parent is in Define mode button will be hidden
        if (!parentItem || (parentItem.RequestedAction === priceListItemActionEnum.Define || !parentItem.RecurringPrice))
            return false;

        return !!item.IsOverridden;
    }

    $scope.ShowCancelButton = function (item) {
        return item.RequestedAction;
    };

    $scope.IsReadOnlyItem = function (item) {
        // For cases when child uses parent item OR we want to inherit price item will be readonly
        return (item.IsOverridden === false && !!item.ParentPriceListId) ||
            item.RequestedAction === priceListItemActionEnum.Inherit;
    };

    $scope.CancelEditingComponentItem = function (item) {
        const clonedItem = $scope.clonedComponentPriceListItems.find(i => i.PriceListId === item.PriceListId && i.ProductId === item.ProductId);

        // In case of canceling Override action when parent item value is undefined, we need to set RecurringPrice to undefined, otherwise we are mapping value from related cloned item
        item.RecurringPrice = !clonedItem.RecurringPrice ? undefined : {...clonedItem.RecurringPrice};
        item.IsOverridden = clonedItem.IsOverridden;
        item.dirty = false;
        item.RequestedAction = undefined;
        $scope.unsavedItems--;
    };

    $scope.CancelEditing = function () {
        if (!$routeParams.componentId) {
            $scope.componentPriceListItems.items.forEach((item) => {
                if (item.dirty === true) {
                    $scope.unsavedItems --;
                    item.dirty = false;
                    item.RecurringPrice = undefined;
                    item.OneOffPrice = undefined;
                    item.RequestedAction = undefined;
                }
            })
            return;
        }
        ProductPrices.query({
            productId: $routeParams.componentId,
            search: $scope.search
        }).$promise.then(
            function (response) {
                $scope.componentPriceListItems.items.forEach((item) => {
                    if (item.dirty === true) {
                        let responseItem = response.filter(r => r.ProductId === item.ProductId && r.PriceListId === item.PriceListId);
                        if (responseItem) {
                            item.OneOffPrice = responseItem[0].OneOffPrice;
                            item.RecurringPrice = responseItem[0].RecurringPrice;
                            item.IsOverridden = responseItem[0].IsOverridden;
                            item.ParentPriceListId = responseItem[0].ParentPriceListId;
                        }
                        else {
                            item.OneOffPrice = null;
                            item.RecurringPrice = null;
                        }
                        $scope.unsavedItems--;
                        item.dirty = false;
                        item.RequestedAction = undefined;
                    }
                });
                SetIsOverriddenFlagAndCloneItems();
            });
    }

    function modify() {
        $scope.savePrices(function () {
            $location.path("/products");
        });
    }

    function create(response) {
        const success = function () {
            $location.path("/products");
        };
        $routeParams.componentId = response.Id;
        $scope.component = Component.get({componentId: $routeParams.componentId},
            function () {
                $scope.savePrices(success);
            });
    }

    $scope.save = function () {
        // Mapping price per unit from default price list item in case default price list is changed
        let defaultPriceList = $scope.fullcomponentPriceListItems.find(x => x.PriceListId === $scope.planGroup.DefaultPriceListId);
        $scope.component.PricePerUnit = defaultPriceList ? defaultPriceList.RecurringPrice?.PricePerUnit : $scope.component.PricePerUnit;
        if ($routeParams.componentId) {
            $scope.component.$update({componentId: $scope.component.Id}, modify);
        } else {
            $scope.component.$save({planGroupId: $routeParams.planGroupId}, create);
        }
    };

    $scope.hasVisibleCustomFields = function () {
        if (!$scope.customFieldSettings)
            return false;
        for (var i = 0; i < $scope.customFieldSettings.length; i++) {
            if ($scope.customFieldSettings[i].EditInUI != 'None')
                return true;
        }
        return false;
    };

    $scope.$watch('component.ComponentType', function () {
        if ($scope.component && $scope.component.ComponentType) {
            if ($scope.component.ComponentType == 'OnOff' && $scope.pricingModel !== "3") {
                $scope.pricingModel = "0";
            }
        }
    });


    CustomFieldSettings.get({customFieldType: 'Product'}, function (data) {
        $scope.customFieldSettings = data.CustomFieldDescriptors;
    });

    $scope.$watch('component.ComponentType', function (newVal, oldVal) {
        if (newVal && oldVal && $scope.component && $scope.component.ComponentType) {
            if ($scope.component.ComponentType === 'Metered') {
                $scope.component.FeePeriod = null;
            } else {
                $scope.component.FeePeriod = {"Quantity": 1, "Unit": "Month"};
            }
        }
    });

    $scope.hidePlural = function (unsavedItems) {
        return String(unsavedItems).slice(-1) === "1";
    };

    $scope.cancel = function () {
        $location.path("/products");
    };
};
ComponentEditController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', '$q', '$uibModal', 'ProductInfo', 'Component', 'ComponentByPlanGroup', 'PlanGroup', 'ProductPrices', 'PriceListItems', 'TaxPolicy', 'CustomFieldSettings'];
